import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, Button, Flex, Box } from "@mantine/core";
function BookingLightbox({ children, open, ctaCancel, ctaForward, ctaForwardCall, onClose }) {
    return /*#__PURE__*/ _jsxs(Modal, {
        opened: open,
        onClose: onClose,
        withCloseButton: false,
        padding: 0,
        style: {
            width: '590px'
        },
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                style: {
                    textAlign: 'center',
                    padding: ' 0 2rem',
                    lineHeight: '2rem'
                },
                children: [
                    ' ',
                    children
                ]
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                justify: "center",
                style: {
                    backgroundColor: '#F7F7F7',
                    padding: '20px',
                    borderTop: '1px solid #C8C9CA',
                    flexWrap: 'wrap'
                },
                gap: 10,
                direction: {
                    base: 'column',
                    lg: 'row'
                },
                children: [
                    ctaCancel && ctaCancel.length && /*#__PURE__*/ _jsx(Button, {
                        onClick: onClose,
                        color: "dark",
                        variant: "outline",
                        styles: {
                            root: {
                                border: 'solid',
                                backgroundColor: 'transparent',
                                borderColor: '#000',
                                fontSize: '1em',
                                borderWidth: 2,
                                color: '#fff',
                                overflow: 'visible',
                                flexGrow: '1',
                                textTransform: 'uppercase',
                                minWidth: 0,
                                maxWidth: '100%'
                            },
                            label: {
                                color: '#000',
                                fontSize: '0.895em'
                            }
                        },
                        children: ctaCancel
                    }),
                    ctaForwardCall && /*#__PURE__*/ _jsx(Button, {
                        onClick: ctaForwardCall,
                        variant: "filled",
                        styles: {
                            label: {
                                fontSize: '0.895em'
                            },
                            root: {
                                flexGrow: '1',
                                fontSize: '1em',
                                overflow: 'visible',
                                textTransform: 'uppercase',
                                minWidth: 0,
                                maxWidth: '100%'
                            }
                        },
                        children: ctaForward
                    })
                ]
            })
        ]
    });
}
export default BookingLightbox;
